module.exports = __webpack_public_path__ + "img/lora_wan.94778e8d.png";